import React from "react";
import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";

export default function Ranked() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: "100vh", color: "white", paddingTop: "80px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", fontFamily: "sans-serif",
      backgroundImage: "url('/background.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" 
    }}>

        <Helmet>
        <title>Ranked | UN-LOCKED</title>
        <meta name="description" content="Play against other Players and Level your Account" />
      </Helmet>
      <style>{`
        button { transition: transform 0.1s ease-in-out, filter 0.1s ease-in-out, box-shadow 0.1s ease-in-out; }
        button:hover { transform: scale(1.05); filter: brightness(1.2); }
      `}</style>
      
      <div style={{ backgroundColor: "rgba(30, 30, 30, 0.8)", padding: "50px", borderRadius: "20px", textAlign: "center", maxWidth: "600px", border: "4px solid gold", backdropFilter: "blur(10px)", boxShadow: "0 10px 30px rgba(0,0,0,0.5)" }}>
        <h1 style={{ color: "white", fontSize: "3.5em", margin: "0 0 10px 0", textShadow: "0 4px 10px rgba(0,0,0,0.8)" }}>Ranked Mode</h1>
        <h2 style={{ color: "gold", marginBottom: "30px", fontSize: "1.5em", letterSpacing: "2px", textTransform: "uppercase" }}>Work in Progress </h2>
        <p style={{ color: "#ccc", lineHeight: "1.6", marginBottom: "40px", fontSize: "1.2em", fontWeight: "bold" }}>
          This Gamemmode is currently under Construction. Come back later to play in Ranked Matches against other Players.
        </p>

        <button onClick={() => navigate("/")} style={{ padding: "15px 40px", fontSize: "1.2em", backgroundColor: "#444", color: "white", border: "2px solid #777", borderRadius: "12px", cursor: "pointer", fontWeight: "bold", boxShadow: "0 5px 15px rgba(0,0,0,0.3)" }}>
          Back to Menu
        </button>
      </div>
    </div>
  );
}